const checkLightMode = () => {
    const darkModeSwitchers = window.document.querySelectorAll('.js-dark-mode');
    const darkModeLabels = window.document.querySelectorAll('.js-dark-mode-label');
    const lightModeActionType = localStorage.getItem('light-mode') === 'light-mode' ? 'add' : 'remove';
    if (!darkModeSwitchers && !darkModeLabels)
        return;
    window.document.body.classList[lightModeActionType]('light-mode');
    [...darkModeSwitchers].forEach((item) => {
        item.classList[lightModeActionType]('active');
    });
    [...darkModeLabels].forEach((item) => {
        if (lightModeActionType === 'add') {
            item.classList.toggle('active');
        }
    });
};
export default checkLightMode;
